const defaultData = {
  name: "",
  price: "",
  discount: "",
  points: "",
  description: [],
  type: "",
  category: "",
  pieces: "",
};
export const messageDetailReducer = (messageDetail = [], action) => {
  const { type, payload } = action;
  switch (type) {
    case "TABLE_DATA_WITH_MESSAGE_STATUS":
      const { message, dish, goods, Read, Completed, Pending } = payload;
      return {
        ...messageDetail,
        statusTypes: { Read: Read, Completed: Completed, Pending: Pending },
        table_data: { message, dish, goods },
      };
    case "CHANGE_DASHBOARD_STATUS":
      const { prev, updated } = payload;

      return {
        ...messageDetail,
        ...(messageDetail.statusTypes[`${prev}`] -= 1),
        ...(messageDetail.statusTypes[`${updated}`] += 1),
      };
    case "CHANGE_STATUS":
      return {
        ...messageDetail,
        table_data: payload,
      };
    case "EDIT_SELECTED_DATA":
      const {
        data: {
          category: cat,
          idx,
          price,
          reservation,
          points,
          name,
          type,
          pieces,
          description,
        },
        discount,
      } = payload;

      return {
        ...messageDetail,
        ...(messageDetail.table_data[`${cat}`][idx] = {
          ...messageDetail.table_data[`${cat}`][idx],
          category: cat,
          price,
          discount,
          reservation,
          points,
          name,
          type,
          pieces,
          description,
        }),
      };
    case "ADD_TO_TABLE_DATA":
      const { data, category } = payload;

      const table_data = messageDetail.table_data[`${category}`];

      return {
        ...messageDetail,
        ...(messageDetail.table_data[`${category}`] = [data, ...table_data]),
      };
    case "VIEW_CLOSE_REQUEST_MODAL":
      return {
        ...messageDetail,
        request_modal_open: payload,
      };
    case "OPEN_ADD_ANNOUNCEMENT_MODAL":
      return {
        ...messageDetail,
        announce_modal: payload,
      };
    case "VIEW_OPEN_REQUEST_MODAL":
      const { data: orderData, request_modal_open } = payload;
      return {
        ...messageDetail,
        orderData,
        request_modal_open,
      };
    case "DELETE_PRODUCT":
      const { id, category: cate_gory } = payload;

      const newData = messageDetail.table_data[`${cate_gory}`].filter(
        (data) => data._id !== id
      );

      return {
        ...messageDetail,
        ...(messageDetail.table_data[`${cate_gory}`] = newData),
      };

    default:
      return messageDetail;
  }
};
